import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress,
  CardActionArea,
  IconButton,
  Chip
} from '@mui/material';
import { BsPencilSquare, BsShareFill, BsTrashFill } from "react-icons/bs";
import Swal from "sweetalert2";

export default function ImageCard({ progress = 0, url, label, labelname, data = {}, onClick, onAction = () => { } }) {
  const handleClick = onClick || (() => { });
  let frame_count = (data.frame_count || data.image_count) || "0"
  const findNoofDays = (date_from, date_to) => {
    const date1 = new Date(date_from);
    const date2 = new Date(date_to);

    // Calculate difference in milliseconds
    const diffInMs = Math.abs(date2 - date1);

    // Convert milliseconds to days
    return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  }

  return (
    <Card className="card-bg1 shadow" sx={{ p: 0, borderRadius: 4, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardActionArea sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'flex-start' }}>
        <Box color={'blue'} display={'flex'} gap={0.2} justifyContent={'end'}>
          <IconButton onClick={(e) => onAction("Share", data, e, url)}
            size="small">
            <BsShareFill title="Share" fontSize={12} />
          </IconButton>
          <IconButton
            onClick={(e) => {
              e.stopPropagation(); // Prevent card click
              Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
              }).then((result) => {
                if (result.isConfirmed) {
                  onAction("Delete", data);
                }
              });
            }}
            size="small"
          >
            <BsTrashFill title="Delete" fontSize={12} />
          </IconButton>
        </Box>
        <Box sx={{ mb: 2 }} className="text">
          <Typography fontSize={14} fontWeight={700}>{label}</Typography>
          <Typography fontSize={14} fontWeight={600}>{labelname}</Typography>
          <Typography fontSize={11} fontWeight={600} variant="body2">
            {data.date_from} - {data.date_to} | No. of Images: {frame_count} of {String(findNoofDays(data?.date_from, data?.date_to)).padStart(3, '0')} Days
          </Typography>
        </Box>

        <Box
          onClick={handleClick}
          component="img"
          src={url}
          alt="Preview"
          loading="lazy"
          onError={(e) => { e.target.style.display = 'none'; }}
          sx={{
            width: '100%',
            height: 120,
            objectFit: 'cover',
            borderRadius: 2,
            mb: 2
          }}
        />

        <CardContent className="text" sx={{ p: 0, display: 'flex', justifyContent: 'space-between', mt: 'auto' }}>
          <Box>
            <Typography fontSize={10}>Created At:</Typography>
            <Typography fontSize={11}>{data?.created_at}</Typography>
            <Typography fontSize={10}>Project:</Typography>
            <Typography fontSize={11}>{data?.project_name}</Typography>
          </Box>
          <Box className="text">
            <Typography fontSize={10}>Company:</Typography>
            <Typography fontSize={11}>{data?.company_name}</Typography>
            {data.camera_type == "TIMELAPSE" ? <Typography variant="body2">Action:
              <IconButton onClick={() => onAction("Edit", data)} size="small">
                <BsPencilSquare />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation(); // Prevent card click
                  Swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!"
                  }).then((result) => {
                    if (result.isConfirmed) {
                      onAction("Delete", data);
                    }
                  });
                }}
                size="small"
              >
                <BsTrashFill />
              </IconButton>
            </Typography> : <>{data?.camera_type && <Chip size="small" sx={{ my: 1 }} label={data.camera_type} />}</>}
          </Box>
        </CardContent>

        <Box sx={{ mt: 2 }}>
          <LinearProgress variant="determinate" value={progress} color="success" />
        </Box>
      </CardActionArea>
    </Card>
  );
}
